import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { LANDING_LINKS } from '@/config/landing-links';
import { SvgIcon } from '@/components/SvgIcon';

import styles from './FooterSupport.module.sass';

export const FooterSupport = () => {
  const { t } = useTranslation();

  return (
    <Link
      to={LANDING_LINKS.TELEGRAM_AML_SUPPORT_BOT_URL}
      rel="noreferrer nofollow"
      target="_blank"
      className={styles.support}
    >
      <SvgIcon name="telegram" />
      {t('translation.landingFooter.support')}
    </Link>
  );
};
